export const GET_PRODUCTS_PENDING = "GET_PRODUCTS_PENDING";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";

export const getProductsPending = () => {
  return { type: GET_PRODUCTS_PENDING };
};

export const getProductsSuccess = (payload) => {
  return { type: GET_PRODUCTS_SUCCESS, payload };
};

export const getProductsError = () => {
  return { type: GET_PRODUCTS_ERROR };
};
